import MainLayout from "@/components/layout/MainLayout";
import { Link } from "react-router-dom";
import ServiceList from "./components/ServiceList";
import ProcessSection from "./components/ProcessSection";
import FaqSection from "./components/FaqSection";
import BenefitsSection from "@/pages/home/components/BenefitsSection";
import CtaSection from "@/pages/home/components/CtaSection";

const heroImage =
  "https://readdy.ai/api/search-image?query=Elegant%20luxurious%20wellness%20spa%20interior%20with%20soft%20warm%20ambient%20lighting%2C%20modern%20body%20care%20technology%20equipment%2C%20natural%20green%20plants%20and%20wood%20elements%2C%20serene%20tranquil%20healthcare%20atmosphere%2C%20cream%20and%20sage%20green%20color%20palette%2C%20editorial%20interior%20photography%2C%20high%20detail&width=1600&height=900&seq=services-hero-01&orientation=landscape";

export default function Services() {
  return (
    <MainLayout>
      {/* SEO structured data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: "Liệu trình có an toàn không?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Hoàn toàn an toàn. Xanh Wellness sử dụng công nghệ cao không xâm lấn, không đau, không cần nghỉ dưỡng.",
              },
            },
            {
              "@type": "Question",
              name: "Mỗi buổi trải nghiệm kéo dài bao lâu?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Mỗi liệu trình kéo dài khoảng 40 phút.",
              },
            },
            {
              "@type": "Question",
              name: "Có cần đặt lịch trước không?",
              acceptedAnswer: {
                "@type": "Answer",
                text: "Bạn nên đặt lịch trước để được sắp xếp khung giờ phù hợp.",
              },
            },
          ],
        })}
      </script>

      {/* Hero header */}
      <section className="relative w-full h-[320px] md:h-[420px] overflow-hidden">
        <img
          src={heroImage}
          alt="Dịch vụ chăm sóc sức khỏe tại Xanh Wellness"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55" />
        <div className="relative w-full h-full flex flex-col items-center justify-center px-4 md:px-8 text-center">
          <nav
            aria-label="Breadcrumb"
            className="flex items-center gap-2 text-xs md:text-sm font-label text-background-200 mb-4"
          >
            <Link to="/" className="hover:text-background-50 transition-colors">
              Trang chủ
            </Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-background-50 font-medium">Dịch vụ</span>
          </nav>
          <h1 className="font-display text-3xl md:text-5xl font-bold text-background-50 mb-4">
            Dịch vụ của chúng tôi
          </h1>
          <p className="text-sm md:text-base text-background-200 max-w-2xl font-body leading-relaxed">
            Công nghệ chăm sóc sức khỏe hiện đại giúp bạn giảm cân, cải thiện vóc dáng và thư giãn cơ thể một cách an toàn, hiệu quả.
          </p>
        </div>
      </section>

      <ServiceList />
      <BenefitsSection />
      <ProcessSection />
      <FaqSection />
      <CtaSection />
    </MainLayout>
  );
}